import { IntlShape } from 'dibs-react-intl';
import { shareViaEmail, mailMessages } from '../helpers/shareHelpers';

type ShareEmailArgs = {
    firmName: string;
    projectName: string;
    photoPath: string;
};

export const onShareEmail = ({
    intl,
    projectName,
    firmName,
    photoPath,
}: ShareEmailArgs & { intl: IntlShape }): void => {
    const body = intl.formatMessage(mailMessages.body, {
        firmName,
        projectName,
    });
    const subject = intl.formatMessage(mailMessages.subject, {});
    shareViaEmail({
        body,
        subject,
        url: photoPath,
    });
};

export const shareViaShareScreen = ({ photoShareUri }: { photoShareUri: string }): void => {
    const data: ShareData = { url: photoShareUri };
    const shareAvailable = !!(navigator && navigator.share);
    if (shareAvailable) {
        navigator.share(data);
    }
};
